import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { LoaderScreen } from '../../components/LoaderScreen';
import request from '../../../Helpers/API';
import { FormatMoney } from '../../../Helpers/FormatNumber';
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { ModalAgregarFinanciamiento } from './Modales/ModalAgregarFinanciamiento';
import { TablaAmortizacionesModal } from '../../Dashboard/Clientes/CapturasDashClientes/PedidoMaquinaria/Modales/TablaAmortizacionesModal';
import { ValPedidoFinanciamientoTablaAmortizacion } from '../../Dashboard/Clientes/CapturasDashClientes/PedidoMaquinaria/Validators/ValPedidoFinanciamientoTablaAmortizacion';

export const ReestructurarCreditoFinanciamientoTab = ({ folio }) => {

    const [unidades, setUnidades] = useState([]);
    const [selectedDocto, setSelectedDocto] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [valorInsoluto, setValorInsoluto] = useState(0);
    const [info, setInfo] = useState({});
    const [tablaAmortizacion, setTablaAmortizacion] = useState({
        tasa: 0,
        plazo: "",
        importe: 0,
        inicio: "",
        binicio: "",
        bimporte: "",
        bplazo: "",
        btasa: "",
    });
    const [tipoAmortizacion, setTipoAmortizacion] = useState("M");
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        if (folio !== null && folio !== undefined && folio !== "") {
            actualizarLista()
        }
    }, [folio]);

    const actualizarLista = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ReestructurarCredito/DetalleFinanciamiento?folio=${folio}`)
            .then((result) => {
                const sumaImportes = result.detalle_financiamiento.reduce(
                    (acc, item) => acc + (parseFloat(item.importefinanciar) || 0),
                    0
                );

                const valorInsoluto =
                    (parseFloat(result.info.valor_operacion) || 0) - sumaImportes;

                setUnidades(result.detalle_financiamiento);
                setInfo(result.info);
                setValorInsoluto(valorInsoluto);
                if (
                    result.info.tipo_amortizacion !== null &&
                    result.info.tipo_amortizacion !== undefined &&
                    result.info.tipo_amortizacion !== ""
                ) {
                    setTipoAmortizacion(result.info.tipo_amortizacion);
                }

                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
            });
    }

    const EliminarRegistro = (item) => {
        Swal.fire({
            title: "Deseas eliminar el registro?",
            showDenyButton: true,
            showCancelButton: true,
            showConfirmButton: false,
            confirmButtonText: "Save",
            cancelButtonText: "Cancelar",
            denyButtonText: `Eliminar`,
        }).then((result) => {
            if (result.isDenied) {
                setLoader({ ...loader, mostrar: true });
                request
                    .get(
                        `ReestructurarCredito/Delete?folio=${item.folio}&docto=${Number(
                            item.docto
                        )}`
                    )
                    .then((result) => {
                        const sumaImportes = result.detalle_financiamiento.reduce(
                            (acc, item) => acc + (parseFloat(item.importefinanciar) || 0),
                            0
                        );
                        const valorInsoluto =
                            (parseFloat(result.info.valor_operacion) || 0) - sumaImportes;

                        setUnidades(result.detalle_financiamiento);
                        setInfo(result.info);
                        setValorInsoluto(valorInsoluto);
                        if (
                            result.info.tipo_amortizacion !== null &&
                            result.info.tipo_amortizacion !== undefined &&
                            result.info.tipo_amortizacion !== ""
                        ) {
                            setTipoAmortizacion(result.info.tipo_amortizacion);
                        }

                        setLoader({ ...loader, mostrar: false });
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
                    });
            }
        });
    };

    // Función para abrir el modal y pasar el 'docto' al estado
    const openModal = (docto) => {
        setSelectedDocto(docto);
        setModalOpen(true);
    };

    // Función para cerrar el modal
    const closeModal = () => {
        setModalOpen(false);
        setSelectedDocto(null);
    };

    const onCrearTablaAmortizacion = () => {
        var result = ValPedidoFinanciamientoTablaAmortizacion(tablaAmortizacion);

        if (result.isValid === false) {
            Swal.fire(
                "PEDIDO DE MAQUINARIA",
                JSON.stringify(result.mensaje),
                "error"
            );
        } else if (result.post.importe < 1) {
            Swal.fire(
                "PEDIDO DE MAQUINARIA",
                "El importe no puede ser menor o igual a 0 para generar la tabla",
                "error"
            );
            return;
        } else if (result.post.tasa < 1) {
            Swal.fire(
                "PEDIDO DE MAQUINARIA",
                "La tasa no puede ser menor o igual a 0 para generar la tabla",
                "error"
            );
            return;
        } else {
            result.post.folio = folio.state.folio;
            result.post.valor_total = info.valor_operacion;

            request
                .post("PedidoFinanciamiento/TablaAmortizaciones", result.post)
                .then(async (result) => {
                    const sumaImportes = result.detalle_financiamiento.reduce(
                        (acc, item) => acc + (parseFloat(item.importefinanciar) || 0),
                        0
                    );
                    const valorInsoluto =
                        (parseFloat(result.info.valor_operacion) || 0) - sumaImportes;

                    setUnidades(result.detalle_financiamiento);
                    setInfo(result.info);
                    setValorInsoluto(valorInsoluto);
                    if (
                        result.info.tipo_amortizacion !== null &&
                        result.info.tipo_amortizacion !== undefined &&
                        result.info.tipo_amortizacion !== ""
                    ) {
                        setTipoAmortizacion(result.info.tipo_amortizacion);
                    }

                    setLoader({ ...loader, mostrar: false });
                })
                .catch((error) => {
                    Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "info");
                });
        }
    };

    const EliminarTodosRegistro = () => {
        Swal.fire({
            title: "¿Deseas eliminar todos los registros?",
            showDenyButton: true,
            showCancelButton: true,
            showConfirmButton: false,
            confirmButtonText: "Save",
            cancelButtonText: "Cancelar",
            denyButtonText: `Eliminar`,
        }).then((result) => {
            if (result.isDenied) {
                setLoader({ ...loader, mostrar: true });
                request
                    .get(`ReestructurarCredito/DeleteAll?folio=${folio}`)
                    .then((result) => {
                        const sumaImportes = result.detalle_financiamiento.reduce(
                            (acc, item) => acc + (parseFloat(item.importefinanciar) || 0),
                            0
                        );
                        const valorInsoluto =
                            (parseFloat(result.info.valor_operacion) || 0) - sumaImportes;

                        setUnidades(result.detalle_financiamiento);
                        setInfo(result.info);
                        setValorInsoluto(valorInsoluto);
                        if (
                            result.info.tipo_amortizacion !== null &&
                            result.info.tipo_amortizacion !== undefined &&
                            result.info.tipo_amortizacion !== ""
                        ) {
                            setTipoAmortizacion(result.info.tipo_amortizacion);
                        }

                        setLoader({ ...loader, mostrar: false });
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
                    });
            }
        });
    };


    return (
        <div className="reestructurar-credito-financiamiento-container">
            <LoaderScreen loader={loader} />
            {/* <button
                className='reestructurar-credito-financiamiento-boton-agregar'
                onClick={() => openModal(-1)}
            >
                <AddCircleIcon />
                Agregar
            </button> */}
            {/* {folio.state.tipo_solicitud === "O" ? ( */}
            <div className="pedido-maquinaria-detalle-financiamiento-container">
                <div className="pedido-maquinaria-detalle-financiamiento-container-info">
                    <div className="pedido-maquinaria-detalle-financiamiento-container-info-cuadro">
                        <div className="pedido-maquinaria-detalle-financiamiento-container-info-cuadro-textos">
                            <div className="info-cuadro-textos-container">
                                <span className="info-cuadro-textos-titulos">
                                    Importe:
                                </span>
                                <div className="info-cuadro-textos-datos">
                                    <div>$</div>
                                    <div>{FormatMoney(info.precio)}</div>
                                </div>
                            </div>
                            <div className="info-cuadro-textos-container">
                                <span className="info-cuadro-textos-titulos">
                                    Descuento:
                                </span>
                                <div className="info-cuadro-textos-datos">
                                    <div>$</div>
                                    <div>{FormatMoney(info.descuento)}</div>
                                </div>
                            </div>
                            <div className="info-cuadro-textos-container">
                                <span className="info-cuadro-textos-titulos">Total:</span>
                                <div className="info-cuadro-textos-datos">
                                    <div>$</div>
                                    <div>{FormatMoney(info.total)}</div>
                                </div>
                            </div>
                            <div className="info-cuadro-textos-container">
                                <span className="info-cuadro-textos-titulos">
                                    Deposito:
                                </span>
                                <div className="info-cuadro-textos-datos">
                                    <div>$</div>
                                    <div>{FormatMoney(info.deposito)}</div>
                                </div>
                            </div>
                            <div className="info-cuadro-textos-container">
                                <span className="info-cuadro-textos-titulos">
                                    Valor de operación:
                                </span>
                                <div className="info-cuadro-textos-datos">
                                    <div>$</div>
                                    <div>{FormatMoney(info.valor_operacion)}</div>
                                </div>
                            </div>
                        </div>
                        <div className="pedido-maquinaria-detalle-financiamiento-container-info-cuadro-botones radio-group scroll">
                            <label>
                                <input
                                    type="radio"
                                    name="opcion"
                                    value="N"
                                    checked={tipoAmortizacion === "N"}
                                    onChange={() => setTipoAmortizacion("N")}
                                    disabled={info.tipo_amortizacion !== null}
                                />
                                Amortización Normal
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="opcion"
                                    value="M"
                                    checked={tipoAmortizacion === "M"}
                                    onChange={() => setTipoAmortizacion("M")}
                                    disabled={info.tipo_amortizacion !== null}
                                />
                                Amortizaciones variables de capital
                            </label>

                            <label>
                                <input
                                    type="radio"
                                    name="opcion"
                                    value="T"
                                    checked={tipoAmortizacion === "T"}
                                    onChange={() => setTipoAmortizacion("T")}
                                    disabled={info.tipo_amortizacion !== null}
                                />
                                Amortizaciones fijas de capital
                            </label>
                        </div>
                    </div>

                    {tipoAmortizacion === "T" &&
                        info.tipo_amortizacion === null && (
                            <TablaAmortizacionesModal
                                tablaAmortizacion={tablaAmortizacion}
                                setTablaAmortizacion={setTablaAmortizacion}
                            />
                        )}
                </div>
                <div className="pedido-maquinaria-detalle-financiamiento-container-boton-add">
                    <button
                        className="pedido-maquinaria-detalle-financiamiento-container-boton-eliminar-todo"
                        onClick={() => EliminarTodosRegistro()}
                    >
                        Borrar amortizaciones
                    </button>

                    {tipoAmortizacion === "T" && info.tipo_amortizacion === null ? (
                        <Button
                            onClick={() => onCrearTablaAmortizacion()}
                            variant="contained"
                            sx={{ height: "30px" }}
                        >
                            Generar amortización
                        </Button>
                    ) : (
                        <Button
                            onClick={() => openModal(-1)}
                            variant="contained"
                            sx={{ height: "30px" }}
                        >
                            Agregar amortización
                        </Button>
                    )}
                </div>
            </div>
            {/* ) : (
                <div className="pedido-maquinaria-detalle-financiamiento-container-boton-JDF">
                    <Button
                        onClick={() => openModal(-1)}
                        variant="contained"
                        sx={{ height: "30px" }}
                    >
                        Agregar amortización
                    </Button>

                    <button
                        className="pedido-maquinaria-detalle-financiamiento-container-boton-eliminar-todo-JDF"
                        onClick={() => EliminarTodosRegistro()}
                    >
                        Borrar amortizaciones
                    </button>
                </div>
            )} */}

            <div className="reestructurar-credito-financiamiento-tabla-container scroll-4">

                <ModalAgregarFinanciamiento
                    open={modalOpen}
                    onClose={closeModal}
                    folio={folio}
                    docto={selectedDocto}
                    tipoAmortizacion={tipoAmortizacion}
                    valorInsoluto={valorInsoluto}
                    actualizarLista={actualizarLista}
                />


                {/* <ModalAgregar /> */}
                <table cellPadding={0} cellSpacing={0}>
                    <thead>
                        <tr>
                            <th>DOCTO</th>
                            <th>VENCIMIENTO</th>
                            <th>IMPORTE A FINANCIAR</th>
                            <th>DIAS</th>
                            <th>TASA %</th>
                            <th>INTERÉS</th>
                            <th>TOTAL A PAGAR</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {unidades === undefined || unidades === null || unidades === 0 ? (
                            <>Sin Datos</>
                        ) : (
                            unidades.map((item, index) => (
                                <tr>
                                    <td>{item.docto}</td>
                                    <td>{item.svencimiento}</td>
                                    <td>{FormatMoney(item.importefinanciar)}</td>
                                    <td>{item.dias}</td>
                                    <td>{FormatMoney(item.tasa)}</td>
                                    <td>{FormatMoney(item.interes)}</td>
                                    <td>{FormatMoney(item.totalpagar)}</td>
                                    {tipoAmortizacion === "M" ? (
                                        <td>
                                            {/* Solo mostrar CreateIcon si es el último elemento */}
                                            {index === unidades.length - 1 && (
                                                <CreateIcon onClick={() => openModal(item.docto)} />
                                            )}
                                        </td>
                                    ) : tipoAmortizacion === "T" ? (
                                        <td></td>
                                    ) : (
                                        <td>
                                            <CreateIcon onClick={() => openModal(item.docto)} />
                                        </td>
                                    )}

                                    {tipoAmortizacion === "M" ? (
                                        <td>
                                            {/* Solo mostrar CreateIcon si es el último elemento */}
                                            {index === unidades.length - 1 && (
                                                <DeleteIcon
                                                    onClick={() => EliminarRegistro(item)}
                                                />
                                            )}
                                        </td>
                                    ) : tipoAmortizacion === "T" ? (
                                        <td></td>
                                    ) : (
                                        <td>
                                            <DeleteIcon onClick={() => EliminarRegistro(item)} />
                                        </td>
                                    )}
                                </tr>
                            ))
                        )}
                    </tbody>

                    <tfoot>
                        <tr>
                            <td>Total</td>
                            <td></td>
                            <td>{FormatMoney(unidades.reduce((sum, item) => sum + Number(item.importefinanciar), 0))}</td>
                            <td></td>
                            <td></td>
                            <td>{FormatMoney(unidades.reduce((sum, item) => sum + Number(item.interes), 0))}</td>
                            <td>{FormatMoney(unidades.reduce((sum, item) => sum + Number(item.totalpagar), 0))}</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tfoot>

                </table>
            </div>
        </div >
    )
}
